import { Pressable, StyleSheet, Text, View } from 'react-native'
import { colors, fontFamily, fontSize, radius, space } from '../tokens'

type Props = { onReset: () => void }

// Branded fallback for the ObservaErrorBoundary. Without it a render crash shows
// a blank screen — the boundary returns null when no fallback is given.
export const ErrorFallback = ({ onReset }: Props) => (
  <View style={styles.container}>
    <Text style={styles.title}>Something went wrong</Text>
    <Text style={styles.body}>
      Sorry — this page hit an unexpected error. Try again, and if it keeps happening, reload the
      page.
    </Text>
    <Pressable accessibilityRole="button" onPress={onReset} style={styles.button}>
      <Text style={styles.buttonText}>Try again</Text>
    </Pressable>
  </View>
)

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: space[24],
    gap: space[16],
    backgroundColor: colors.bg,
  },
  title: {
    fontSize: 22,
    fontWeight: '700',
    color: colors.ink,
    fontFamily: fontFamily.body,
  },
  body: {
    fontSize: fontSize.small,
    color: colors.muted,
    textAlign: 'center',
    lineHeight: 22,
    maxWidth: 360,
    fontFamily: fontFamily.body,
  },
  button: {
    marginTop: space[8],
    backgroundColor: colors.primary[700],
    paddingHorizontal: space[24],
    paddingVertical: 12,
    borderRadius: radius.md,
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 15.5,
    fontWeight: '600',
    fontFamily: fontFamily.body,
  },
})
